import Cookies from 'js-cookie';

const TokenKey = 'accessToken'; // 主token
const UseridKey = 'userId'; // 用户系统内id
const UsernameKey = 'userName'; // 用户中文名
const LoginNumberKey = 'loginNumber'; // 登录账号手机号

const OwnerId = 'ownerId';

const RefreshTokenKey = 'refreshToken'; // 刷新续约用的token
const ExpiresTime = 'expiresTime'; // 续约时间

const LOGINACCOUNT = 'userAccount';
const checkPlatform = 'checkPlatform';

// 登录客服账号存储的信息
const tcccToken = 'tcccToken';
const tcccSdkAppId = 'tcccSdkAppId';
const tcccUserId = 'tcccUserId';
const tcccSdkUrl = 'tcccSdkUrl';

// 账号信息
export function setToken(token) {
	return Cookies.set(TokenKey, token);
}
export function setUserId(userId) {
	return Cookies.set(UseridKey, userId);
}
export function setUserName(userName) {
	return Cookies.set(UsernameKey, userName);
}
export function setOwnerId(ownerId) {
	return Cookies.set(OwnerId, ownerId);
}
export function setLoginNumber(loginNumber) {
	return Cookies.set(LoginNumberKey, loginNumber);
}

export function getToken() {
	return Cookies.get(TokenKey);
}
export function getUserId() {
	return Cookies.get(UseridKey);
}
export function getUserName() {
	return Cookies.get(UsernameKey);
}
export function getOwnerId() {
	return Cookies.get(OwnerId);
}
export function getLoginNumber() {
	return Cookies.get(LoginNumberKey);
}

// token刷新过期时间相关
export function setRefreshToken(refresh_token) {
	return Cookies.set(RefreshTokenKey, refresh_token);
}
export function setExpiresTime(expires_in) {
	return Cookies.set(ExpiresTime, expires_in);
}
export function getRefreshToken() {
	return Cookies.get(RefreshTokenKey);
}
export function getExpiresTime() {
	return Cookies.get(ExpiresTime);
}

export function removeToken() {
	//return sessionStorage.clear();
	return Cookies.remove(TokenKey);
}

// 检查平台是否已经开通
export function setCheckPlatform(checkFlag) {
	return Cookies.set(checkPlatform, checkFlag);
}
export function getCheckPlatform() {
	return Cookies.get(checkPlatform);
}

// 设置和获取客服账号登录后的字段
export function setTcccData(parameter) {
	Cookies.set(tcccToken, parameter.token);
	Cookies.set(tcccSdkAppId, parameter.sdkAppId);
	Cookies.set(tcccUserId, parameter.userId);
	Cookies.set(tcccSdkUrl, parameter.sdkUrl);
	return;
}
export function getTcccData() {
	let data = {
		token: Cookies.get(tcccToken),
		sdkAppId: Cookies.get(tcccSdkAppId),
		userId: Cookies.get(tcccUserId),
		sdkUrl: Cookies.get(tcccSdkUrl),
	}
	return data;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js